import { filter } from 'd3'
import ActionType from '../action.types'

/*
    Reducer function to push data to the store in case of different signin action types
*/
var initialstate = {
  isLoading: false,
  patients: [],
  metadata: {},
  sorter: {},
  activity: {},
  measurement: {},
  selectedPatients: {},
  filters: {
    type: 'active',
  },
  search: '',
  // Schedule view for the active patient list (client-side filter).
  //
  // 'scheduled' is DELIBERATE and was re-confirmed 2026-10-28. Do not change
  // it to 'all' without reading this first.
  //
  // The daily user of this dashboard is the HEALTH COACH, who works the
  // scheduled caseload every day and does not want unscheduled patients in
  // the list. Clinics handle scheduling outside the platform and rarely log
  // in. Defaulting to 'all' would tax every coach on every visit to spare a
  // user who is hardly ever here.
  //
  // It HAS caused a scare: on 2026-10-28 two patients self-registered without
  // a known surgery date -- which transmits today + 1 year
  // (physio_app_web components/login/registration.js) and lands them in Not
  // Scheduled -- and the clinic saw an empty table under a header still
  // reading "Active: 2". The fix was to make the filter legible, not to
  // widen it: the tabs now carry counts and an empty list says what is
  // hiding and offers Show All (util/patientlistfilters, patient.filter.js,
  // patient.table.js).
  scheduleView: 'scheduled',
  patient: {},
  // TracPatch Progress-Test (active ROM) records for the open patient.
  romTests: [],
  newpatient: {},
  notifications: [],
  isActive:true,
  diagnoses: [],
  billingData: null
}

export default function patient_operation(state = initialstate, action) {
  switch (action.type) {
    case ActionType.PATIENT_INPROGRESS:
      return { ...state, isLoading: action.isLoading }
    case ActionType.SET_PATIENT_ROM:
      return { ...state, romTests: action.roms }
    case ActionType.PATIENT_LIST:
      return {
        ...state,
        error: action.hasError,
        patients: action.patients,
        metadata: action.metadata,
        filters: action.filters,
        sorter: action.sorter,
        selectedPatients: action.selectedPatients,
      }
    case ActionType.COMPANY_PATIENT_LIST:
      return {
        ...state,
        companyPatientFilter: action.filters,
        companyPatients: action.patients,
        companyMetaData: action.metadata,
      }
    case ActionType.ROW_SELECT:
      return { ...state, selectedPatients: action.selectedPatients }
    case ActionType.SERVICE_ERROR:
      return { ...state, error: action.hasError, message: action.message }
    case ActionType.NOTIFY:
      return {
        ...state,
        notifyError: action.notifyError,
        notifyMessage: action.notifyMessage,
      }
    case ActionType.MAIL:
      return {
        ...state,
        mailError: action.mailError,
        mailMessage: action.mailMessage,
      }
    case ActionType.STATS:
      return { ...state, stats: action.stats }
    case ActionType.SET_PATIENT:
      return { ...state, patient: action.patient }
    case ActionType.SET_ACTIVITIES:
      return { ...state, activity: action.activity }
    case ActionType.SET_MEASUREMENTS:
      return { ...state, measurement: action.measurement }
    case ActionType.SET_NEW_PATIENT:
      return { ...state, newpatient: action.newpatient }
    case ActionType.SET_PAT_NT:
      return { ...state, notifications: action.notifications }
    case ActionType.SET_PAT_ACTIVITYLOG:
      return { ...state, activitylogs: action.activitylogs }
      case ActionType.SET_PAT_ISACTIVE:
        return { ...state, isActive: action.isActive }  
    case ActionType.SET_FILTER:
      return { ...state, filters: action.filters }
    case ActionType.SET_PATIENT_SEARCH:
      return { ...state, search: action.search }
    case ActionType.SET_PATIENT_SCHEDULE_VIEW:
      return { ...state, scheduleView: action.scheduleView }
    case ActionType.SET_ACTIVE_DEVICES:
      return { ...state, activeDevices: action.activeDevices }  
    case ActionType.GET_PATIENT_DIAGNOSES_SUCCESS:
      return { ...state, diagnoses: action.payload }
    case ActionType.GET_BILLING_DATA_SUCCESS:
      return { ...state, billingData: action.payload }
    case ActionType.LOGOUT:
      return initialstate
    default:
      return state
  }
}
